import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { PreviewProjectResponse } from '@hellodarwin/core/lib/features/entities';
import { dollarFormat } from '@hellodarwin/core/lib/features/helpers';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Invoices from '@hellodarwin/icons/dist/icons/Invoices';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import PriorityTileInfo from './priority-tile-info';
import {
  InfoContainer,
  PriorityTileContainer,
  TileContentContainer,
  TitleContainer,
} from './styles';

export interface PriorityTileProps {
  priority: PreviewProjectResponse;
}

const PriorityTile: React.FC<PriorityTileProps> = ({ priority }) => {
  const theme = useTheme();
  const { selectedLocale } = useLocale();
  const { pathname } = useLocation();
  const { t } = useTranslations();

  return (
    <Link to={`${pathname}/${priority.project_id}`}>
      <PriorityTileContainer>
        <TitleContainer>
          <Typography elementTheme="subtitle2">{priority.title}</Typography>
          <Typography elementTheme="body3" color={theme.colors.purple_2} medium>
            {t('project|budgetTotal', {
              budgetTotal: priority.total_budget
                ? dollarFormat(priority.total_budget, selectedLocale, true)
                : '-',
            })}
          </Typography>
        </TitleContainer>
        <TileContentContainer>
          <InfoContainer>
            <PriorityTileInfo
              Icon={Invoices}
              value={t('project|applicationsTotal', {
                total: `${priority.total_programs || 0}`,
              })}
            />
          </InfoContainer>
          <Button defaultStyle={theme.colors.purple_2} withArrowRight>
            {t('project|viewProject')}
          </Button>
        </TileContentContainer>
      </PriorityTileContainer>
    </Link>
  );
};

export default PriorityTile;
